import OrderApi from "@/api/pig-registration/piglet/PigletOrderApi";
export default {
  namespaced: true,
  states: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, items) {
      try {
        const response = await OrderApi.addOrUpdate(items);
        await dispatch('NOTIFY_MSG', 'pigRegistration.notification.savePigletTransport', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchByWeekId({dispatch}, {weekId}) {
      try {
        const response = await OrderApi.fetchByWeekId(weekId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async move({dispatch}, {orderId, calendarWeekId}) {
      try {
        const response = await OrderApi.move(orderId, calendarWeekId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async split({dispatch}, {orderId}) {
      try {
        const response = await OrderApi.split(orderId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async remove({dispatch}, {orderId}) {
      try {
        const response = await OrderApi.remove(orderId);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
